import { message } from "antd";
import { useAuth } from "navigation/Auth/ProvideAuth";
import CodeVerificationWidget from "components/CodeVerificationWidget/CodeVerificationWidget";

import { REGISTER_WITH } from "config/CONSTANTS";
import {
  ROOT,
  ROUTE_BECOME_VENDOR,
  ROUTE_DASHBOARD,
  ROUTE_REGISTER,
} from "navigation/CONSTANTS";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { UpdateCurrentRoot, UpdateQrCodeList } from "redux/actions/appActions";
import { updateUser } from "redux/actions/userActions";
import InputPage from "./InputPage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { showChooseTypeDialog } from "pages/HomePage/Layout/ChooseTypeDialog/showChooseTypeDialog";

const LOGIN_PAGES = {
  InputPage: "InputPage",
  ActivationCodePage: "ActivationCodePage",
  InputLocationPage: "InputLocationPage",
};
const pageList = [
  LOGIN_PAGES.InputPage,
  LOGIN_PAGES.ActivationCodePage,
  LOGIN_PAGES.InputLocationPage,
];
function SignupPage(props) {
  const history = useHistory();
  const appDataStore = useSelector((x) => x.appDataStore);
  const dispatch = useDispatch();
  const auth = useAuth();
  const [userDetail, setUserDetail] = useState({
    first_name: "",
    last_name: "",
    email: "",
    cell_phone: "",
    password: "",
    confirm_password: ""
  });
  const [isBusy, setIsBusy] = useState(false);
  const [registrationInfo, setRegistrationInfo] = useState(null);
  const [step, setStep] = useState(0)
  useEffect(() => {
    dispatch(updateUser({ camp_users: [], first_name: "", last_name: "", email: "", cell_phone: "", token: undefined }));
    if (appDataStore?.appInfo?.registration_info) {
      setRegistrationInfo(appDataStore?.appInfo?.registration_info)
    } else {
      setRegistrationInfo(null);
    }
  }, []);

  const onSubmit = async () => {
    if (step == 0) {
      onSignup();
    } else if (step == 1) {
      onConfirmCode();
    }
  };
  const onSignup = () => {
    setIsBusy(true);
    auth
      .signup(userDetail)
      .then((res) => {
        setIsBusy(false)
        if (res.result) {
          setStep(1)
        } else {
          console.log(res.msg)
          message.error(res.msg)
        }
      })
      .catch((err) => {
        setIsBusy(false)
        message.error(err);
      });
  }
  const onConfirmCode = () => {
    setIsBusy(true);
    auth
      .verifySignup(userDetail)
      .then((res) => {
        setIsBusy(false)
        if (res.result) {
          message.success(res.msg);
          onSuccessLogin(res.token);
        } else {
          message.error(res.msg)
        }
      })
      .catch((err) => {
        setIsBusy(false)
        message.error(err);
      });
  }
  const onSuccessLogin = async (token) => {
    dispatch(updateUser({ first_name: userDetail.first_name, last_name: userDetail.last_name, email: userDetail.email, cell_phone: userDetail.cell_phone, token }));

    // let dlgRes = await showChooseTypeDialog({ appInfo: appDataStore?.appInfo });
    // if (dlgRes == null) return;
    // localStorage.setItem("camper_registration_type", dlgRes)
    history.push(ROUTE_REGISTER)
  };
  return (
    <div style={{ color: 'var(--blackColor)', backgroundColor: 'var(--whiteColor)' }}>
      <InputPage
        onSubmit={onSubmit}
        userDetail={userDetail}
        setUserDetail={setUserDetail}
        isBusy={isBusy}
        registrationInfo={registrationInfo}
        step={step}
        setStep={setStep}
      />
    </div>
  );
}

export default withRouter(SignupPage);
